import { NOOP } from "@web-monorepo/fetchers";
import { useSearchParams } from "react-router-dom";
import WhoseTurn from "components/WhoseTurn/WhoseTurn";
import { useParentStudentsFetcher } from "src/pods/parentStudents/useParentStudentsFetcher";

export default function WhoseTurnPage() {
  const [params] = useSearchParams();
  const { parentId } = Object.fromEntries(params.entries());
  const { data: students } = useParentStudentsFetcher(parentId ? { parentId } : NOOP);

  return <WhoseTurn students={students ?? []} />;
}
